<template>
  <div class="emergency-page">
    <div class="card-wrap">
      <h1>Modo de emergencia activo</h1>
      <p>El sitio esta pausado. Ingresa el token para reanudar operaciones.</p>

      <div v-if="error" class="alert error">{{ error }}</div>
      <div v-if="success" class="alert success">{{ success }}</div>

      <CInput
        v-if="!success"
        type="password"
        label="Token de reanudacion"
        placeholder="Ingresa token"
        v-model="token"
        @keydown.enter="resumeSite"
      />

      <CButton v-if="!success" color="primary" block @click="resumeSite" :disabled="submitting">
        {{ submitting ? 'Reanudando...' : 'Reanudar sitio' }}
      </CButton>
    </div>
  </div>
</template>

<script>
import emergency from '@/services/emergency'

export default {
  name: 'EmergencyResume',
  data() {
    return {
      token: '',
      error: '',
      success: '',
      submitting: false,
    }
  },
  async created() {
    await this.ensurePausedMode()
  },
  methods: {
    async ensurePausedMode() {
      try {
        const response = await emergency.status()
        const paused = !!(response && response.data && response.data.site_paused)

        if (!paused) {
          this.$router.replace({ name: '404' })
        }
      } catch (e) {
        this.$router.replace({ name: '404' })
      }
    },
    async resumeSite() {
      this.error = ''
      this.success = ''

      if (!this.token || this.token.trim() === '') {
        this.error = 'El token es obligatorio.'
        return
      }

      this.submitting = true

      try {
        const response = await emergency.resume({ token: this.token.trim() })
        if (response.type === 'success') {
          this.success = response.message || 'Sitio reanudado correctamente.'
          this.token = ''

          this.$router.replace({ path: '/login' })
          return
        }

        this.error = response.message || 'No se pudo reanudar el sitio.'
      } catch (e) {
        this.error = (e.response && e.response.data && e.response.data.message)
          ? e.response.data.message
          : 'No se pudo reanudar el sitio.'
      } finally {
        this.submitting = false
      }
    },
  },
}
</script>

<style scoped>
.emergency-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(165deg, #f3f6fb 0%, #e3eaf5 100%);
  padding: 20px;
}

.card-wrap {
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #d5deec;
  box-shadow: 0 14px 30px rgba(35, 55, 97, 0.14);
  padding: 24px;
}

h1 {
  font-size: 24px;
  margin: 0 0 8px;
  color: #1e2d4f;
}

p {
  color: #4f607e;
  margin-bottom: 16px;
}

.alert {
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 10px 12px;
  font-size: 14px;
}

.error {
  background: #ffe8e8;
  border: 1px solid #f6bfbf;
  color: #9b1e1e;
}

.success {
  background: #e8f8ee;
  border: 1px solid #beeacc;
  color: #1f6f37;
}
</style>
